"use client"
import { RenderConfig, TeamMemberProps } from "@/(admin)/modules/ui-builder/config/blocks/TeamMember/RenderConfig"
import { ComponentConfig } from "@measured/puck"
import { MediaSelect } from "../../../../media/pages/SelectMediaUIBuilder"
import { commonStylesProps } from "../../lib/commonCSSProps"

export const TeamMember: ComponentConfig<TeamMemberProps> = {
  label: "Team Member",
  //@ts-ignore
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    subtitle: {
      label: "Subtitle",
      type: "text",
    },
    teamMembers: {
      label: "Team Members",
      type: "array",
      arrayFields: {
        name: {
          label: "Name",
          type: "text",
        },
        position: {
          label: "Position",
          type: "text",
        },
        image: {
          label: "Image",
          type: "custom",
          render: props => <MediaSelect {...props} />,
        },
        description: {
          label: "Description",
          type: "textarea",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "Đội ngũ",
    subtitle: "Đội ngũ",
    teamMembers: [
      {
        name: "Danny Phan",
        position: "Founder/Manager Director",
        image: "",
        description:
          "Hơn 9 năm kinh nghiệm trong xây dựng và phát triển phần mềm, chuyên sâu về chiến lược sản phẩm và tái cấu trúc quy trình, giúp doanh nghiệp tối ưu hiệu suất và thúc đẩy tăng trưởng bền vững.",
      },
      {
        name: "Danny Phan",
        position: "Founder/Manager Director",
        image: "",
        description:
          "Hơn 9 năm kinh nghiệm trong xây dựng và phát triển phần mềm, chuyên sâu về chiến lược sản phẩm và tái cấu trúc quy trình, giúp doanh nghiệp tối ưu hiệu suất và thúc đẩy tăng trưởng bền vững.",
      },
      {
        name: "Danny Phan",
        position: "Founder/Manager Director",
        image: "",
        description:
          "Hơn 9 năm kinh nghiệm trong xây dựng và phát triển phần mềm, chuyên sâu về chiến lược sản phẩm và tái cấu trúc quy trình, giúp doanh nghiệp tối ưu hiệu suất và thúc đẩy tăng trưởng bền vững.",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
